"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUMMY_VALIDATION_ID = exports.VALIDATION_ERROR_CODES = exports.VALIDATION_TYPE = void 0;
exports.resolveValidationId = resolveValidationId;
exports.validateClientValidationId = validateClientValidationId;
exports.validateExecutiveValidationId = validateExecutiveValidationId;
exports.validateGroupId = validateGroupId;
exports.isValidationError = isValidationError;
exports.parseApiResponse = parseApiResponse;
exports.VALIDATION_TYPE = {
    BIOMETRIC: 1001,
    Q_AND_A: 1002,
    FACIAL_RECOGNITION: 1003,
    CUE: 1004,
    ELECTRONIC_SIGN: 1005
};
exports.VALIDATION_ERROR_CODES = {
    ID_REQUIRED: "ValidationIdRequired",
    ID_INVALID_FORMAT: "ValidationIdInvalidFormat",
    METHOD_NOT_SUPPORTED: "ValidationMethodNotSupported"
};
var ERROR_NAME = "PreviredValidationIdError";
var FIELD_PATTERN = /(clientValidationId|executiveValidationId|groupId)/;
// Same formats enforced by fulfillment-previred-api (ValidationIdValidator)
var UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var ULID = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/;
// Valid UUID v4 used only for non-production dummy runs, where the auth-widget does not return a usable id
exports.DUMMY_VALIDATION_ID = "00000000-0000-4000-8000-000000000000";
function resolveValidationId(id, allowDummy) {
    var value = normalize(id);
    if (!allowDummy)
        return value || undefined;
    return UUID_V4.test(value) ? value : exports.DUMMY_VALIDATION_ID;
}
function roleOf(field) {
    return field === "executiveValidationId" ? "ejecutivo" : "cliente";
}
function userMessageFor(code, field) {
    var role = roleOf(field);
    switch (code) {
        case exports.VALIDATION_ERROR_CODES.ID_REQUIRED:
            return "No se obtuvo el identificador de validaci\u00F3n de identidad del ".concat(role);
        case exports.VALIDATION_ERROR_CODES.ID_INVALID_FORMAT:
            return "El identificador de validaci\u00F3n de identidad del ".concat(role, " tiene un formato inv\u00E1lido");
        case exports.VALIDATION_ERROR_CODES.METHOD_NOT_SUPPORTED:
            return "El m\u00E9todo de validaci\u00F3n de identidad del ".concat(role, " no es v\u00E1lido para esta operaci\u00F3n");
        default:
            return "Error en la validación de identidad";
    }
}
function buildError(code, field, message) {
    return { name: ERROR_NAME, code: code, field: field, message: message, userMessage: userMessageFor(code, field) };
}
function invalid(code, field, message) {
    return { valid: false, error: buildError(code, field, message) };
}
function normalize(id) {
    return typeof id === "string" ? id.trim() : "";
}
function clientFormat(validationType) {
    if (validationType === exports.VALIDATION_TYPE.BIOMETRIC || validationType === exports.VALIDATION_TYPE.FACIAL_RECOGNITION) {
        return UUID_V4;
    }
    return validationType === exports.VALIDATION_TYPE.ELECTRONIC_SIGN ? ULID : null;
}
function executiveFormat(validationType) {
    return validationType === exports.VALIDATION_TYPE.BIOMETRIC ? UUID_V4 : null;
}
function check(field, id, validationType, format, required) {
    var value = normalize(id);
    var notSupported = function () {
        return invalid(exports.VALIDATION_ERROR_CODES.METHOD_NOT_SUPPORTED, field, "Validation method ".concat(validationType, " is not valid for ").concat(field));
    };
    if (!value) {
        if (!required)
            return { valid: true };
        return format
            ? invalid(exports.VALIDATION_ERROR_CODES.ID_REQUIRED, field, "".concat(field, " is required"))
            : notSupported();
    }
    if (!format)
        return notSupported();
    if (!format.test(value)) {
        return invalid(exports.VALIDATION_ERROR_CODES.ID_INVALID_FORMAT, field, "".concat(field, " has an invalid format"));
    }
    return { valid: true, value: value };
}
function validateClientValidationId(id, validationType, required) {
    if (required === void 0) { required = true; }
    return check("clientValidationId", id, validationType, clientFormat(validationType), required);
}
function validateExecutiveValidationId(id, validationType, required) {
    if (required === void 0) { required = true; }
    return check("executiveValidationId", id, validationType, executiveFormat(validationType), required);
}
// groupId is optional: it can be missing when the authentication failed before being registered
function validateGroupId(id) {
    var value = normalize(id);
    if (!value)
        return { valid: true };
    return ULID.test(value)
        ? { valid: true, value: value }
        : invalid(exports.VALIDATION_ERROR_CODES.ID_INVALID_FORMAT, "groupId", "groupId has an invalid format");
}
function isValidationError(error) {
    return !!error && error.name === ERROR_NAME;
}
function isApiValidationCode(code) {
    return (code === exports.VALIDATION_ERROR_CODES.ID_REQUIRED ||
        code === exports.VALIDATION_ERROR_CODES.ID_INVALID_FORMAT ||
        code === exports.VALIDATION_ERROR_CODES.METHOD_NOT_SUPPORTED);
}
function fromApiError(body) {
    var message = typeof body.message === "string" ? body.message : body.code;
    var match = FIELD_PATTERN.exec(message);
    return buildError(body.code, match ? match[1] : "clientValidationId", message);
}
// Parses the response body and turns the API 400 validation errors into IValidationIdError rejections
function parseApiResponse(response) {
    return response.json().then(function (body) {
        if (response.status === 400 && body && isApiValidationCode(body.code)) {
            throw fromApiError(body);
        }
        return body;
    });
}
